import React, { Component } from 'react';

import Configs from 'Configuration';
import SiteConfigurationContext from 'Utils/SiteConfigurationContext';
import FhtFetchUrl from 'Utils/FhtFetchUrl.jsx';
import FhtMain from 'FhtMain';

import {
  Box,
  Button,
  Grid,
  Paper,
  Snackbar,
  TextField,
  Typography,
} from '@material-ui/core';

import {
  DataGrid
} from '@material-ui/data-grid';

import SnackbarContentWrapper from 'components/SnackbarContentWrapper';

const columns = [
  {
    field: 'lastName',
    headerName: 'Last name',
    sortable: false,
    width: 180,
  },
  {
    field: 'firstName',
    headerName: 'First name',
    sortable: false,
    width: 180,
  },
  {
    field: 'smsSendDate',
    headerName: 'Most Recent SMS',
    sortable: false,
    width: 180,
  },
  {
    field: 'mobileNumber',
    headerName: 'Mobile Number',
    sortable: false,
    width: 200,
  },
  {
    field: 'surveyLink',
    headerName: 'Survey Link',
    sortable: false,
    width: 450,
  },
  {
    field: 'comments',
    headerName: 'Comments',
    sortable: false,
    width: 450,
    editable: true
  },
];

class WebProjectPatientEligibility extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // Data
      patientDataIsLoading: true,
      patientData: [],
      patientDataRowCount: 0,
      patientPageNumber: 0,
      patientPageSize: 20,
      patientSelectionModel: [],
      filterFirstname: '',
      filterSurname: '',
      // Snackbar
      snackbarOpen: false,
      snackbarMessage: "",
      snackbarVariant: "info"
    };

    this.getPatientData();
  }

  render() {
    return (
      <Box maxWidth={1800} margin="auto">
        {this.renderSnackbar()}
        <Typography variant="h3" gutterBottom>Contact List</Typography>
        <Grid container spacing={3}>
          <Grid item sm={12}>
            <Paper>
              <Box sx={{ padding: 12 }}>
                <Typography variant="h6" gutterBottom>Patients</Typography>
                <Typography variant="subtitle1" gutterBottom>
                  View and manage patients eligible for the WEB program.
                </Typography>
                <Box paddingBottom={2}>
                  <Grid container spacing={3}>
                    <Grid item sm={12} md={4}>
                      <TextField
                        id="filter-last-name"
                        label="Last Name"
                        value={this.state.filterSurname}
                        onChange={(event) => this.setState({ filterSurname: event.target.value })}
                        fullWidth
                      />
                    </Grid>
                    <Grid item sm={12} md={4}>
                      <TextField
                        id="filter-first-name"
                        label="First Name"
                        value={this.state.filterFirstname}
                        onChange={(event) => this.setState({ filterFirstname: event.target.value })}
                        fullWidth
                      />
                    </Grid>
                    <Grid item sm={12} md={2}>
                      <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "flex-end", width: '100%', height: '100%' }}>
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={() => this.resetSearch()}
                        >
                          Reset
                        </Button>
                      </Box>
                    </Grid>
                    <Grid item sm={12} md={2}>
                      <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "flex-end", width: '100%', height: '100%' }}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => this.getPatientData(0, this.state.patientPageSize)}
                        >
                          Search
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "flex-start" }} paddingBottom={2}>
                  <div style={{ height: 600, width: '100%' }}>
                    <DataGrid
                      loading={this.state.patientDataIsLoading}
                      rows={this.state.patientData}
                      rowCount={this.state.patientDataRowCount}
                      columns={columns}
                      pagination
                      paginationMode='server'
                      onPageChange={(page) => this.onPageChange(page)}
                      page={this.state.patientPageNumber}
                      pageSize={this.state.patientPageSize}
                      rowsPerPageOptions={[20]}
                      disableColumnFilter
                      disableColumnMenu
                      onCellEditCommit={(params) => this.handleCellEditCommit(params)}
                    />
                  </div>
                </Box>
                <Grid container spacing={1} justifyContent="center">
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => this.downloadCsv()}
                    >
                      Download CSV
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    );
  }

  async onPageChange(page) {
    await this.getPatientDataPaginated(page, this.state.patientPageSize);
  }

  async resetSearch() {
    this.setState({
      filterSurname: "",
      filterFirstname: "",
      patientPageNumber: 0,
    });

    await this.getPatientData();
  }

  async getPatientData() {
    await this.getPatientDataPaginated(this.state.patientPageNumber, this.state.patientPageSize);
  }

  async getPatientDataPaginated(page, pageSize) {
    try {
      this.setState({
        patientData: [],
        patientPageNumber: page,
        patientPageSize: pageSize,
        patientSelectionModel: [],
        patientDataIsLoading: true,
      });

      // Get patients
      let patientsApiUrl = `${Configs.getPatientsWebEligibilityStatus}?page=${page}&pageSize=${pageSize}`;
      if (this.state.filterSurname)
        patientsApiUrl += `&filterSurname=${this.state.filterSurname}`;
      if (this.state.filterFirstname)
        patientsApiUrl += `&filterFirstname=${this.state.filterFirstname}`;

      const patientsApi = FhtFetchUrl(patientsApiUrl);
      const response = await patientsApi.get();

      console.log(response);
      const patientData = response.data.map(x => ({
        id: x.patientData.patientExtractId,
        firstName: x.patientData.patientExtractFirstname,
        lastName: x.patientData.patientExtractSurname,
        mobileNumber: x.patientData.patientExtractMobileNumber,
        age: x.patientData.patientExtractAge,
        smsSendDate: x.patientAppointmentToSms.appointmentToSMSDateCreated,
        surveyLink: x.patientAppointmentToSms.appointmentToSMSRedcapUrlLink,
        comments: x.patientData.patientExtractComment ?? "",
      }));

      const patientDataRowCount = response.totalRows;

      this.setState({
        patientData,
        patientDataRowCount,
        patientPageNumber: page,
        patientPageSize: pageSize,
        patientDataIsLoading: false,
      });
    } catch (error) {
      console.error(error);
      this.setState({ snackbarMessage: "Error getting eligible patients", snackbarVariant: "error", openSnackbar: true });
    }
  }

  async setPatientData(patientId, patientComment) {
    this.setState({
      patientData: [],
      patientSelectionModel: [],
    });

    // Get patients
    const patientsApi = FhtFetchUrl(Configs.setPatientComment);
    const patientsApiBody = {
      patientId,
      patientComment
    };

    await patientsApi.post(patientsApiBody)
      .then(async () => {
        this.setState({ snackbarMessage: `Updated comments for patient`, snackbarVariant: "success", openSnackbar: true });
        await this.getPatientData();
      })
      .catch(async () => {
        this.setState({ snackbarMessage: "Error updating patient comments", snackbarVariant: "error", openSnackbar: true });
        await this.getPatientData();
      });
  }

  async downloadCsv() {
    const siteConfigurationContext = SiteConfigurationContext();

    const url = `${siteConfigurationContext[Configs.SiteConfigurationMappingKeys.serverapi]}${Configs.getPatientsWebEligibilityCsv}`;
    const a = document.createElement('a')
    a.href = url
    a.download = url.split('/').pop()
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }

  onSelectionModelChange(model) {
    console.log(model);
    this.setState({ patientSelectionModel: model });
  }

  async handleCellEditCommit(params, event) {
    if (params.field === "comments") {
      await this.setPatientData(params.id, params.value);
    }
  }

  renderSnackbar() {
    return (
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={this.state.openSnackbar}
        autoHideDuration={4000}
        onClose={() => this.setState({ openSnackbar: false })}
      >
        <SnackbarContentWrapper
          onClose={() => this.setState({ openSnackbar: false })}
          variant={this.state.snackbarVariant}
          message={this.state.snackbarMessage}
        />
      </Snackbar>
    );
  }
}

export default WebProjectPatientEligibility;
